import React from 'react';
import {
  GridPage,
  LeftSideOfPage,
  RightSideOfPage,
  BackLinkCell,
} from 'styles';
import { routes, copyFor } from 'config';
import { BackLink } from 'components/back-link';
import { Explainer } from 'pages/advocacy/components/explainer';
import { AddressForm } from './address-form/address-form.component';

const getBackLinkCopy = copyFor('navigation.backLink.dashboardLocations');

export const Address = () => {
  const { dashboard } = routes();

  return (
    <GridPage>
      <BackLinkCell>
        <BackLink to={dashboard} location={getBackLinkCopy('dashboard')} />
      </BackLinkCell>
      <LeftSideOfPage>
        <AddressForm />
      </LeftSideOfPage>
      <RightSideOfPage>
        <Explainer />
      </RightSideOfPage>
    </GridPage>
  );
};
